// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"0ecc657d","112":"d1438bd0","186":"4adf6ead","445":"04725997","986":"bd4efbee"}[chunkId] + ".chunk.js";
};